import React, { useCallback, useContext, useEffect } from 'react';
import useStyles from '../../../../style/js-style/containers/administration/personalization/personalizationStyle';
import i18next from 'i18next';
import EAIcon from '../../../../components/common/EAIcon';
import { useDropzone } from 'react-dropzone'
import { Context } from '../../../../states/Store';
import { useFormContext } from 'react-hook-form';
import { ERROR } from 'services/common/Constants';

const LogoInput = ({inputItem, setUploadedLogo, setHasRemovedLogo, hasRemovedLogo, preview, setPreview, disabled}) => {
  const { classes } = useStyles();
  const [state, dispatch] = useContext(Context);
  const isNormalLogo = true;

  const formMethods = useFormContext();
  const {
    setValue
  } = formMethods;

  const onDrop = useCallback((acceptedFiles) => {
    if (!disabled){
      const uploadedFile = acceptedFiles[0];

      // verify if file is less than 500ko
      if (uploadedFile.size > 500000) {
        dispatch({ type: "ALERT", alert: { type: ERROR, msg: i18next.t('personalization.logoError') } });
      } else {
        setPreview([Object.assign(uploadedFile, {
          preview: URL.createObjectURL(uploadedFile)
        })]);
        setUploadedLogo(uploadedFile);
      }
    }

  }, [dispatch, setPreview, setUploadedLogo, disabled])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: {
      'image/png': ['.png']
    },
  })

  // En cas de suppression du logo
  const handleDeleteLogo = () => {
    setPreview([]);
    setUploadedLogo(null);
    setHasRemovedLogo(true);
    setValue('logoURI', null);
  }

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    return () => preview.forEach(file => URL.revokeObjectURL(file.preview));
  }, [preview]);

  return (
    <div className={classes.inputWrapper} style={{ marginTop: '8px' }}>
      <div {...!disabled && {...getRootProps()}}>
        <input {...getInputProps()} />
        <div
          className={classes.inputItemInputWrapperLogo}
          style={{
            backgroundColor: isNormalLogo ? '#F2F3F7' : '#C6CBD9',
            border: isDragActive ? '2px dashed grey' : '2px solid transparent',
          }}
        >
          {preview.length > 0
            ? (
              <img
                src={preview[0].preview}
                style={{ maxWidth: '129px', maxHeight: '51px' }}
                // Revoke data uri after image is loaded
                onLoad={() => {
                  URL.revokeObjectURL(preview[0].preview)
                }}
                alt={"logo"} />
            )
            : state.personalization.logoURI && !hasRemovedLogo ? (
            <img
              src={state.personalization.logoURI}
              alt="logo"
              style={{ maxWidth: '129px', maxHeight: '51px' }}
            />
          ) : (
            <EAIcon
              icon={
                isNormalLogo
                  ? 'personalization/aprovallNormal'
                  : 'personalization/aprovallReverse'
              }
            />
          )}
          <EAIcon
            icon={'personalization/camera'}
            className={classes.camaraIcon}
          />
        </div>
      </div>

      <div className={classes.inputItemLabelWrapper}>
        <div className={classes.inputItemLogoTitle}>{inputItem.title}</div>
        <div className={classes.inputItemLogoNotice}>{inputItem.notice}</div>
        <div
          className={classes.inputItemRemoveImage}
          onClick={!disabled ? handleDeleteLogo : () => {}}
          style={{ opacity: disabled ? .4 : 1 }}
        >
          {i18next.t('personalization.appearanceTab.logo.removeImage')}
        </div>
      </div>
    </div>
  );
}

export default LogoInput;